import React, { Component } from 'react';
import {
  Route,
  BrowserRouter as Router,
  withRouter,
  Redirect,
  Switch
} from 'react-router-dom';

import PropTypes from 'prop-types';
import R from 'ramda';
import ReferralCatcher from '../../common/support/ReferralCatcher';

import ScreenCreateApp from '../screens/ScreenCreateApp';
import ScreenSignup from '../screens/ScreenSignup';
import ScreenLogin from '../screens/ScreenLogin';
import ScreenResetPassword from '../screens/ScreenResetPassword';
import ScreenVerifyEmail from '../screens/ScreenVerifyEmail';
import ScreenAcceptInvite from '../screens/ScreenAcceptInvite';
import ScreenResendEmail from '../screens/ScreenResendEmail';
import ScreenSetPassword from '../screens/ScreenSetPassword';
import ScreenSsoLogin from '../screens/ScreenSsoLogin';

// Instrumentation
import { setupI13n } from 'react-i13n';
import I13nMixpanelPlugin from '../../common/support/mixpanel';

class App extends Component {
  /**
   * handles redirect for SSO users and users with no apps
   */
  handleRedirect = () => {
    const { pathname } = this.props.location;
    const currentAppError = R.path(['App', 'context', 'view', 'error'], window);
    const sso = R.path(['App', 'context', 'ssoSubdomain'], window);

    let redirectRoute = pathname;

    if (currentAppError === 'empty_app_list' && !sso) {
      redirectRoute = '/create';
    } else if (currentAppError === 'empty_app_list' && sso) {
      redirectRoute = '/sso/login/error';
    } else if (sso) {
      redirectRoute = '/sso/login';
    } else if (!sso && pathname.indexOf('sso') > -1) {
      redirectRoute = '/login';
    }

    if (redirectRoute !== pathname) {
      this.props.history.push(redirectRoute);
    }
  };

  render() {
    this.handleRedirect();

    return (
      <div className="loggedout">
        <Switch>
          <Route path="/" component={ScreenSignup} exact />
          <Route path="/login" component={ScreenLogin} exact />
          <Route path="/login/:reset_key" component={ScreenSetPassword} />
          <Route path="/login-accept" component={ScreenLogin} exact />
          <Route
            path="/login-accept/:accept_key"
            component={ScreenSetPassword}
          />
          <Route path="/verify" component={ScreenVerifyEmail} />
          <Route path="/accept-email-invite" component={ScreenAcceptInvite} />
          <Route
            path="/resend-verification-email"
            component={ScreenResendEmail}
          />
          <Route path="/reset" component={ScreenResetPassword} />
          <Route path="/create" component={ScreenCreateApp} />
          <Route path="/sso/login" component={ScreenSsoLogin} exact />
          <Route path="/sso/login/:error" component={ScreenSsoLogin} />
          <Redirect from="*" to="/" />
        </Switch>
      </div>
    );
  }
}

App.contextTypes = {
  i13n: PropTypes.object
};

const AppWithRouter = withRouter(App);

const RouterLoggedout = () => {
  ReferralCatcher.storeExternalReferrer();

  return (
    <Router>
      <Route path="/" component={AppWithRouter} />
    </Router>
  );
};

export default setupI13n(RouterLoggedout, { rootModelData: { site: 'DB' } }, [
  I13nMixpanelPlugin
]);
